import { connect } from "react-redux";
import { GetDataConfirmAction, GetDataPlanHandleStepAction } from "../actions";
import ConfirmPageComponents from "../components/ConfirmPage";

const mapStateToProps = state => {
    return {
        ...state,
        isResult: state.allConfirmPageReducers.isResultReducer.isResult,
        DataPlan:  state.allConfirmPageReducers.ConfirmPageReducer.DataPlan,
        DataPlanStep: state.allConfirmPageReducers.RejectPageReducer.DataPlanStep
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataConfirm: (DataPlan) => {
            dispatch(GetDataConfirmAction(DataPlan));
        },
        GetDataPlanHandleStep: (DataPlanStep) =>{
            dispatch(GetDataPlanHandleStepAction(DataPlanStep))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPageComponents)